var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('homeHeader',{attrs:{"title":"员工档案"}}),_c('div',{staticClass:"main"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"toolbar-dv"},[_c('toolBarBtn',{ref:"toolBarBtn",attrs:{"parentData":this,"buttonVisible":_vm.buttonVisible,"moreButtonList":_vm.moreButtonList}})],1),_c('div',{staticClass:"table-dv"},[_c('vxe-grid',{ref:"xTable",attrs:{"border":"","resizable":"","keep-source":"","size":"mini","column-config":{ minWidth: '80px' },"edit-rules":_vm.validRules,"columns":_vm.tableColumns,"height":_vm.tableHeight,"mouse-config":{ area: true, extension: true },"edit-config":{
            trigger: 'dblclick',
            mode: 'cell',
            activeMethod: _vm.activeMethod
          },"highlight-hover-row":"","highlight-current-row":"","keyboard-config":{
            isArrow: true,
            isEnter: true,
            isTab: true,
            enterToTab: true,
            isClip: true,
            isEdit: true,
            editMethod: _vm.editMethod
          },"data":_vm.tableData,"menu-config":{
            body: { options: _vm.bodyMenus },
            visibleMethod: _vm.visibleMethod
          }},on:{"menu-click":_vm.contextMenuClickEvent,"cell-menu":_vm.cellContextMenuEvent}})],1)])]),_c('PickPosition',{ref:"PickPosition",attrs:{"positionOptions":_vm.positionOptions,"visiblePosition":_vm.selectVisiblePositionArr},on:{"sureBackPosition":_vm.sureBackPosition}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }